<template>
  <div class="home">
    <h1 class="title">全国档案查询利用服务平台</h1>
    <p class="text">预约查档</p>
    <img src="@/assets/phone.png" alt="" />

    <button class="download-btn" @click="handleDownload">
      <div class="ico">📱</div>
      下载APP
    </button>

    <a
      href="https://www.saac.gov.cn/daj/qgdacxlyfwptapp/202507/39bf6e8d8c734e2782b115b5276f07e2.shtml"
      class="manual-btn"
      ><div class="ico">📖</div>
      操作手册</a>
    <p class="foot"><img src="@/assets/logo.png" />绵阳档案馆</p>

    <div class="tan" v-show="show">
      <p>全国档案查询利用服务平台</p>
      <p>点击右上角 <i class="el-icon-more"></i> 然后在浏览器中下载</p>
      <el-button type="primary" class="btn" @click="show = false;">我知道了</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      show: false,
    };
  },
  methods: {
    handleDownload() {
      // 判断是否是微信环境
      const ua = window.navigator.userAgent.toLowerCase();
      const isWeChat = ua.indexOf("micromessenger") > -1;
      if (isWeChat) {
        this.show = true;
      } else {
        window.location.href =
          "https://cxly.saac.gov.cn/file-service/apk/%E5%85%A8%E5%9B%BD%E6%A1%A3%E6%A1%88%E6%9F%A5%E8%AF%A2%E5%88%A9%E7%94%A8%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0.apk";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, #63acff, #cde6ff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  .title {
    color: #ffffff;
    font-size: 24px;
    font-weight: 900;

  }
  .text {
    color: #fff;
    font-size: 20px;
    font-weight: 900;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
    margin-top: 20px;
  }
  img {
    height: 320px;
    margin-top: 40px;
  }
  .download-btn {
    background: #4883db;
    color: #fff;
    border: none;
    padding: 15px 50px;
    border-radius: 25px;
    font-size: 16px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-decoration: none;
    transition: all 0.2s ease;
    box-shadow: 0 4px 15px #bfd9ff;
    margin-top: 40px;
  }
  .download-btn:hover {
    background: #6297e7;
    transform: translateY(-1px);
  }
  .manual-btn {
    background: rgba(255, 255, 255, 0.2);
    color: #004eb4;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 12px 30px;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-decoration: none;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    margin-top: 15px;
  }

  .manual-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }
  .foot {
    margin-top: -10px;
    color: #1570b5;
    font-size: 14px;
    img {
      height: 13px;
      margin-right: 5px;
    }
  }
  .tan {
    position: absolute;
    top: 35%;
    height: 150px;
    width: 300px;
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    border: 1px solid rgb(38, 146, 234);
    padding: 10px;
    p {
      font-size: 16px;
      margin-bottom: 10px;
    }
    .btn {
      width: 200px;
    }
  }
}
</style>
  